import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plan-professional",
  "use": "plan-professional-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 32 32\" id=\"plan-professional\"><path fill=\"#00A8FF\" d=\"M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16\" opacity=\".12\" /><path fill=\"#00A8FF\" fill-rule=\"evenodd\" d=\"M24 16a15.55 15.55 0 0 0-8 8 15.55 15.55 0 0 0-8-8 15.55 15.55 0 0 0 8-8 15.55 15.55 0 0 0 8 8\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol